// import * as React from 'react';
// import Button from "@mui/material/Button";
// import Menu from "@mui/material/Menu";
// import AppsIcon from '@mui/icons-material/Apps';
// import Typography from "@mui/material/Typography";
// import Box from "@mui/material/Box";
// import { CircularProgress, Divider, Grid, List, ListItem, ListItemText, ListSubheader } from "@mui/material";
// import { AndroidApp } from "../../../../public/svg/AndroidApp";
// import { IosApp } from "../../../../public/svg/IosApp";
// import CorporateFareIcon from '@mui/icons-material/CorporateFare';
// import { Link } from 'react-router-dom';
// import { useDispatch, useSelector } from "react-redux";
// import { RootState } from "../../../../store/store";
// import { setProsCatFooter } from "../../../../store/userPros/userProsSlice";
// import { useTranslation } from "react-i18next";
// import SupportAgentIcon from '@mui/icons-material/SupportAgent';
// import LocalOfferIcon from '@mui/icons-material/LocalOffer';
// import BuildIcon from '@mui/icons-material/Build';
// import blogImage from '../../../../public/navbar/blog.png'
// import affiliateImage from '../../../../public/navbar/Affiliate.png'
// import faqImage from '../../../../public/navbar/faq.png'
// import { categoriesDate } from "../../../../date/categories";



// export const MyMenu = () => {
//     const { t, i18n } = useTranslation();
//     const dispatch = useDispatch();

//     const { responseCategoryCity, loadingPros } = useSelector((state: RootState) => state.pros)

//     const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
//     const open = Boolean(anchorEl);

//     const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
//         setAnchorEl(event.currentTarget);
//     };

//     const handleClose = () => {
//         setAnchorEl(null);
//     };


//     return (
//         <Box sx={{
//             display: { xs: 'none', md: 'flex', }
//         }}>
//             {open && <Box sx={{
//                 position: 'fixed',
//                 top: 100,
//                 left: 0,
//                 width: '100%',
//                 height: '100%',
//                 backdropFilter: 'blur(5px)',
//                 zIndex: 1,
//             }}
//             />}
//             <Button
//                 onClick={handleClick}
//                 sx={{
//                     color: "#6B7280",
//                     textTransform: 'capitalize',
//                 }}
//             >
//                 <AppsIcon />
//                 <Typography variant="body2">{t('navBar.services')}</Typography>
//             </Button>
//             <Menu
//                 anchorEl={anchorEl}
//                 open={open}
//                 onClose={handleClose}
//                 aria-labelledby="basic-demo-button"
//                 sx={{
//                     '.MuiPaper-root': {
//                         backgroundColor: "#f3f3f8",
//                         width: '100%',
//                         maxWidth: '100%',
//                         marginLeft: '15px',
//                         marginTop: "15px",

//                         borderRadius: "0px 0px 35px 35px",
//                         padding: 3
//                     }
//                 }}
//             >
//                 <Grid container spacing={2} sx={{
//                     display: "flex",
//                     justifyContent: "space-around",
//                 }}>
//                     <List
//                         subheader={
//                             <ListSubheader
//                                 sx={{ fontWeight: 600, fontSize: "17px", marginBottom: "-5px;", marginTop: "1px", color: "#9CA3AF", backgroundColor: "#f3f3f8", borderBottom: "solid", borderTop: "solid rgba(0, 0, 0, 0.07)", paddingBottom: 0 }}
//                                 component="div" id="list-subheader">
//                                 {t('footer.blockLinkSecond.categories')}
//                             </ListSubheader>
//                         }
//                         sx={{
//                             maxHeight: '200px',
//                             maxWidth: "300px",
//                             overflowY: 'auto',
//                             boxShadow: 'inset 0 0 3px rgba(0, 0, 0, 0.2)',
//                             paddingTop: 0,
//                             paddingRight: 3,
//                             paddingBottom: 3,
//                             paddingLeft: 3,
//                         }}
//                     >
//                         {loadingPros && <CircularProgress />}

//                         {responseCategoryCity?.categories?.map((service: any) => {
//                             const matchedCategory = categoriesDate.find(cat => cat.original === service);

//                             return (
//                                 <Link
//                                     key={service}
//                                     to={`/${i18n.language}/pros`}
//                                     onClick={() => {
//                                         dispatch(setProsCatFooter(service));
//                                         setAnchorEl(null);
//                                     }}
//                                 >
//                                     <ListItem sx={{ color: "#6B7280", fontSize: 14 }}>
//                                         {matchedCategory
//                                             ? i18n.language === "en"
//                                                 ? matchedCategory.original
//                                                 : matchedCategory.translation
//                                             : service}
//                                     </ListItem>
//                                 </Link>
//                             );
//                         })}

//                     </List>
//                     <Grid
//                         sx={{
//                             display: "flex",
//                             flexDirection: "column",
//                             alignItems: "center",
//                             border: "1px solid #e5e7eb",
//                             borderRadius: "10px",
//                             padding: "20px",
//                             boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
//                             textAlign: "center",
//                             maxHeight: "200px"
//                         }}
//                     >
//                         <Link to={`/${i18n.language}/contact-us`} style={{ textDecoration: "none", color: "inherit", }} onClick={handleClose}>
//                             <Box
//                                 sx={{
//                                     display: "flex",
//                                     alignItems: "center",
//                                     justifyContent: "center",
//                                     marginTop: "15px",
//                                 }}
//                             >
//                                 <img
//                                     src={affiliateImage}
//                                     alt="Rascoin Logo"
//                                     style={{ width: "90px", height: "90px", marginRight: "10px" }}
//                                 />
//                                 <Typography variant="body1" sx={{ fontWeight: "bold" }}>
//                                     {t('navBar.affiliateTitle')}
//                                 </Typography>
//                             </Box>
//                             <Typography
//                                 variant="body2"
//                                 sx={{ color: "#6b7280", maxWidth: "300px" }}
//                             >
//                                 {t('navBar.affiliateBody')}
//                             </Typography>
//                         </Link>
//                     </Grid>

//                     <Grid
//                         sx={{
//                             display: "flex",
//                             flexDirection: "column",
//                             alignItems: "center",
//                             border: "1px solid #e5e7eb",
//                             borderRadius: "10px",
//                             padding: "20px",
//                             boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
//                             textAlign: "center",
//                             maxHeight: "200px"
//                         }}
//                     >
//                         <Link to={`/${i18n.language}/bloglist`} style={{ textDecoration: "none", color: "inherit", }} onClick={handleClose}>
//                             <Box
//                                 sx={{
//                                     display: "flex",
//                                     alignItems: "center",
//                                     justifyContent: "center",
//                                     marginTop: "15px",
//                                 }}
//                             >
//                                 <img
//                                     src={blogImage}
//                                     alt="Rascoin Logo"
//                                     style={{ width: "90px", height: "90px" }}
//                                 />
//                                 <Typography variant="body1" sx={{ fontWeight: "bold" }}>
//                                     Read our latest blogs
//                                 </Typography>
//                             </Box>
//                         </Link>
//                     </Grid>

//                     <Grid
//                         sx={{
//                             display: "flex",
//                             flexDirection: "column",
//                             boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
//                             border: "1px solid #E5E7EB",
//                             borderRadius: "5px",
//                             padding: "10px",
//                             maxHeight: "200px"
//                         }}
//                     >
//                         <Link to={`${i18n.language}/FAQ`} onClick={handleClose}>
//                             <Box
//                                 sx={{
//                                     display: "flex",
//                                     alignItems: "center",
//                                     justifyContent: "center",
//                                     marginTop: "15px",
//                                 }}
//                             >
//                                 <img
//                                     src={faqImage}
//                                     alt="Rascoin Logo"
//                                     style={{ width: "50px", height: "50px", margin: "5px" }}
//                                 />
//                                 <Typography variant="body1" sx={{ fontWeight: "bold" }}>
//                                     FAQ
//                                 </Typography>
//                             </Box>
//                         </Link>
//                         <Divider />
//                         <Typography sx={{ px: 2, fontSize: "12px", color: "#6B7280" }}>{i18n.language === "en" ? '(Coming soon...)' : "(A venir...)"}</Typography>
//                         <Grid item sx={{
//                             display: "flex",
//                             marginTop: "10px",
//                         }}>
//                             <Box sx={{ marginRight: "15px" }}>
//                                 <AndroidApp />
//                             </Box>
//                             <IosApp />
//                         </Grid>
//                     </Grid>
//                 </Grid>
//                 <Box>
//                     <Box mt={3} mb={3} sx={{ display: 'flex', alignItems: 'center' }}>
//                         <Divider sx={{ flexGrow: 1 }} />
//                         <Typography sx={{ px: 2, fontSize: "16px", color: "#6B7280" }}>{t('navBar.corporateClients')}</Typography>
//                         <Divider sx={{ flexGrow: 7 }} />
//                     </Box>
//                     <Grid
//                         sx={{
//                             display: "flex",
//                             flexDirection: "column",
//                             alignItems: "center",
//                             border: "1px solid #e5e7eb",
//                             borderRadius: "10px",
//                             padding: "20px",
//                             boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
//                             textAlign: "center",
//                             maxHeight: "200px",
//                         }}
//                     >
//                         <Link
//                             to={`${i18n.language}/contact-us`}
//                             style={{ textDecoration: "none", color: "inherit" }}
//                             onClick={handleClose}
//                         >
//                             <Box
//                                 sx={{
//                                     display: "flex",
//                                     alignItems: "center",
//                                     justifyContent: "center",
//                                     marginTop: "15px",
//                                 }}
//                             >
//                                 <CorporateFareIcon sx={{ fontSize: 24, marginRight: "8px", color: "#6b21a8" }} />
//                                 <Typography variant="body1" sx={{ fontWeight: "bold" }}>
//                                     {t('navBar.corporate')} - {t('navBar.contactUs')}
//                                 </Typography>
//                             </Box>
//                             <List sx={{ padding: 0 }}>
//                                 <ListItem disablePadding>
//                                     <ListItemText
//                                         primary={
//                                             <>
//                                                 <SupportAgentIcon
//                                                     sx={{ fontSize: 20, color: "#6b21a8", marginRight: "8px" }}
//                                                 />
//                                                 {i18n.language === "en"
//                                                     ? "Demo products of interest."
//                                                     : "Démonstration des produits d'intérêt"}
//                                             </>
//                                         }
//                                     />
//                                 </ListItem>
//                                 <ListItem disablePadding>
//                                     <ListItemText
//                                         primary={
//                                             <>
//                                                 <LocalOfferIcon
//                                                     sx={{ fontSize: 20, color: "#6b21a8", marginRight: "8px" }}
//                                                 />
//                                                 {i18n.language === "en"
//                                                     ? "Flexible payment methods"
//                                                     : "Modes de paiement flexibles"}
//                                             </>
//                                         }
//                                     />
//                                 </ListItem>
//                                 <ListItem disablePadding>
//                                     <ListItemText
//                                         primary={
//                                             <>
//                                                 <BuildIcon
//                                                     sx={{ fontSize: 20, color: "#6b21a8", marginRight: "8px" }}
//                                                 />
//                                                 {i18n.language === "en"
//                                                     ? "Get started faster with dedicated implementation and support services."
//                                                     : "Démarrez plus rapidement avec des services dédiés d'implémentation et de support."}
//                                             </>
//                                         }
//                                     />
//                                 </ListItem>
//                             </List>
//                         </Link>
//                     </Grid>
//                 </Box>
//             </Menu>
//         </Box >
//     );
// }





import * as React from 'react';
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import AppsIcon from '@mui/icons-material/Apps';
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { CircularProgress, Divider, Grid, List, ListItem, ListItemText, ListSubheader } from "@mui/material";
import { AndroidApp } from "../../../../public/svg/AndroidApp";
import { IosApp } from "../../../../public/svg/IosApp";
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../store/store";
import { setProsCatFooter } from "../../../../store/userPros/userProsSlice";
import { useTranslation } from "react-i18next";
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import BuildIcon from '@mui/icons-material/Build';
import blogImage from '../../../../public/navbar/blog.png'
import affiliateImage from '../../../../public/navbar/Affiliate.png'
import faqImage from '../../../../public/navbar/faq.png'
import { categoriesDate } from "../../../../date/categories";

export const MyMenu = () => {
    const { t, i18n } = useTranslation();
    const dispatch = useDispatch();

    const { responseCategoryCity, loadingPros } = useSelector((state: RootState) => state.pros)

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
            {open && (
                <Box
                    sx={{
                        position: 'fixed',
                        top: 100,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backdropFilter: 'blur(5px)',
                        zIndex: 1,
                    }}
                />
            )}
            <Button
                onClick={handleClick}
                sx={{
                    color: "#64FFDA",
                    textTransform: 'capitalize',
                    '&:hover': {
                        color: "#9333ea",
                    }
                }}
            >
                <AppsIcon />
                <Typography variant="body2" sx={{ ml: 1 }}>
                    {t('navBar.services')}
                </Typography>
            </Button>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                aria-labelledby="basic-demo-button"
                sx={{
                    '.MuiPaper-root': {
                        backgroundColor: "#112240",
                        color: "#fff",
                        width: '100%',
                        maxWidth: '100%',
                        marginLeft: '15px',
                        marginTop: "15px",
                        borderRadius: "0px 0px 25px 25px",
                        padding: 3,
                        boxShadow: "0 0 20px rgba(147, 51, 234, 0.5)"
                    }
                }}
            >
                <Grid
                    container
                    spacing={2}
                    sx={{
                        display: "flex",
                        justifyContent: "space-around",
                    }}
                >
                    {/* Categories list */}
                    <List
                        subheader={
                            <ListSubheader
                                sx={{
                                    fontWeight: 600,
                                    fontSize: "17px",
                                    mb: "-5px",
                                    mt: "1px",
                                    color: "#64FFDA",
                                    backgroundColor: "transparent",
                                    borderBottom: "1px solid rgba(255,255,255,0.1)",
                                    borderTop: "1px solid rgba(255,255,255,0.1)",
                                    pb: 0
                                }}
                                component="div"
                                id="list-subheader"
                            >
                                {t('footer.blockLinkSecond.categories')}
                            </ListSubheader>
                        }
                        sx={{
                            maxHeight: '200px',
                            maxWidth: "300px",
                            overflowY: 'auto',
                            boxShadow: 'inset 0 0 5px rgba(147, 51, 234, 0.3)',
                            pt: 0,
                            px: 3,
                            pb: 3,
                            borderRadius: "10px",
                            background: "rgba(59, 7, 100, 0.2)"
                        }}
                    >
                        {loadingPros && <CircularProgress color="inherit" />}

                        {responseCategoryCity?.categories?.map((service: any) => {
                            const matchedCategory = categoriesDate.find(cat => cat.original === service);

                            return (
                                <Link
                                    key={service}
                                    to={`/${i18n.language}/pros`}
                                    onClick={() => {
                                        dispatch(setProsCatFooter(service));
                                        setAnchorEl(null);
                                    }}
                                    style={{ textDecoration: "none" }}
                                >
                                    <ListItem
                                        sx={{
                                            color: "#fff",
                                            fontSize: 14,
                                            "&:hover": { color: "#64FFDA" }
                                        }}
                                    >
                                        {matchedCategory
                                            ? i18n.language === "en"
                                                ? matchedCategory.original
                                                : matchedCategory.translation
                                            : service}
                                    </ListItem>
                                </Link>
                            );
                        })}
                    </List>

                    {/* Affiliate box */}
                    <Grid
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            border: "1px solid rgba(255,255,255,0.1)",
                            borderRadius: "15px",
                            padding: "20px",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.4)",
                            textAlign: "center",
                            maxHeight: "200px",
                            background: "linear-gradient(135deg, #3b0764, #9333ea)",
                            color: "#fff",
                        }}
                    >
                        <Link
                            to={`/${i18n.language}/contact-us`}
                            style={{ textDecoration: "none", color: "inherit" }}
                            onClick={handleClose}
                        >
                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", mt: 2 }}>
                                <img
                                    src={affiliateImage}
                                    alt="Affiliate"
                                    style={{ width: "90px", height: "90px", marginRight: "10px" }}
                                />
                                <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                                    {t('navBar.affiliateTitle')}
                                </Typography>
                            </Box>
                            <Typography variant="body2" sx={{ color: "#e0e0e0", maxWidth: "300px", mt: 1 }}>
                                {t('navBar.affiliateBody')}
                            </Typography>
                        </Link>
                    </Grid>

                    {/* Blog box */}
                    <Grid
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            border: "1px solid rgba(255,255,255,0.1)",
                            borderRadius: "15px",
                            padding: "20px",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.4)",
                            textAlign: "center",
                            maxHeight: "200px",
                            background: "rgba(59,7,100,0.3)",
                            color: "#fff",
                        }}
                    >
                        <Link
                            to={`/${i18n.language}/bloglist`}
                            style={{ textDecoration: "none", color: "inherit" }}
                            onClick={handleClose}
                        >
                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", mt: 2 }}>
                                <img
                                    src={blogImage}
                                    alt="Blog"
                                    style={{ width: "90px", height: "90px" }}
                                />
                                <Typography variant="body1" sx={{ fontWeight: "bold", mt: 1 }}>
                                    Read our latest blogs
                                </Typography>
                            </Box>
                        </Link>
                    </Grid>

                    {/* FAQ box */}
                    <Grid
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            border: "1px solid rgba(255,255,255,0.1)",
                            borderRadius: "15px",
                            padding: "10px",
                            maxHeight: "200px",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.4)",
                            background: "rgba(59,7,100,0.3)",
                            color: "#fff",
                        }}
                    >
                        <Link to={`${i18n.language}/FAQ`} onClick={handleClose} style={{ textDecoration: "none", color: "inherit" }}>
                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", mt: 2 }}>
                                <img
                                    src={faqImage}
                                    alt="FAQ"
                                    style={{ width: "50px", height: "50px", margin: "5px" }}
                                />
                                <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                                    FAQ
                                </Typography>
                            </Box>
                        </Link>
                        <Divider sx={{ borderColor: "rgba(255,255,255,0.1)" }} />
                        <Typography sx={{ px: 2, fontSize: "12px", color: "#aaa" }}>
                            {i18n.language === "en" ? '(Coming soon...)' : "(A venir...)"}
                        </Typography>
                        <Grid item sx={{ display: "flex", mt: 1 }}>
                            <Box sx={{ mr: 2 }}>
                                <AndroidApp />
                            </Box>
                            <IosApp />
                        </Grid>
                    </Grid>
                </Grid>

                {/* Divider corporate section */}
                <Box>
                    <Box mt={3} mb={3} sx={{ display: 'flex', alignItems: 'center' }}>
                        <Divider sx={{ flexGrow: 1, borderColor: "rgba(255,255,255,0.2)" }} />
                        <Typography sx={{ px: 2, fontSize: "16px", color: "#64FFDA" }}>
                            {t('navBar.corporateClients')}
                        </Typography>
                        <Divider sx={{ flexGrow: 7, borderColor: "rgba(255,255,255,0.2)" }} />
                    </Box>
                    <Grid
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            border: "1px solid rgba(255,255,255,0.1)",
                            borderRadius: "15px",
                            padding: "20px",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.4)",
                            textAlign: "center",
                            maxHeight: "200px",
                            background: "rgba(59,7,100,0.3)",
                            color: "#fff",
                        }}
                    >
                        <Link
                            to={`${i18n.language}/contact-us`}
                            style={{ textDecoration: "none", color: "inherit" }}
                            onClick={handleClose}
                        >
                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", mt: 2 }}>
                                <CorporateFareIcon sx={{ fontSize: 24, mr: 1, color: "#64FFDA" }} />
                                <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                                    {t('navBar.corporate')} - {t('navBar.contactUs')}
                                </Typography>
                            </Box>
                            <List sx={{ p: 0 }}>
                                <ListItem disablePadding>
                                    <ListItemText
                                        primary={
                                            <>
                                                <SupportAgentIcon sx={{ fontSize: 20, color: "#9333ea", mr: 1 }} />
                                                {i18n.language === "en"
                                                    ? "Demo products of interest."
                                                    : "Démonstration des produits d'intérêt"}
                                            </>
                                        }
                                    />
                                </ListItem>
                                <ListItem disablePadding>
                                    <ListItemText
                                        primary={
                                            <>
                                                <LocalOfferIcon sx={{ fontSize: 20, color: "#9333ea", mr: 1 }} />
                                                {i18n.language === "en"
                                                    ? "Flexible payment methods"
                                                    : "Modes de paiement flexibles"}
                                            </>
                                        }
                                    />
                                </ListItem>
                                <ListItem disablePadding>
                                    <ListItemText
                                        primary={
                                            <>
                                                <BuildIcon sx={{ fontSize: 20, color: "#9333ea", mr: 1 }} />
                                                {i18n.language === "en"
                                                    ? "Get started faster with dedicated implementation and support services."
                                                    : "Démarrez plus rapidement avec des services dédiés d'implémentation et de support."}
                                            </>
                                        }
                                    />
                                </ListItem>
                            </List>
                        </Link>
                    </Grid>
                </Box>
            </Menu>
        </Box>
    );
};
